import { createFileRoute } from "@tanstack/react-router";
import LegalPage from "@/components/LegalPage";

export const Route = createFileRoute("/pet-policy")({
  head: () => ({
    meta: [
      { title: "Pet Policy — Backland" },
      {
        name: "description",
        content:
          "Backland's pet policy: fees, leash rules, occupancy limits, and guidelines for staying with your dog.",
      },
      { property: "og:title", content: "Pet Policy — Backland" },
      {
        property: "og:description",
        content: "Bringing your pet to Backland — fees, rules, and guidelines.",
      },
      { property: "og:url", content: "https://www.travelbackland.com/pet-policy" },
    ],
    links: [{ rel: "canonical", href: "https://www.travelbackland.com/pet-policy" }],
  }),
  component: PetPolicyPage,
});

function PetPolicyPage() {
  return (
    <LegalPage eyebrow="Policy" title="Pet Policy">
      <p>
        Backland is pleased to welcome you and your pet. To ensure that everyone has an
        amazing and safe experience, please familiarize yourself with the following policies.
      </p>
      <ul>
        <li>
          There is a $50 nonrefundable pet fee per stay that will be billed to your tent.
          Additional cleaning and/or repair charges may be incurred due to pet stains and/or
          damages.
        </li>
        <li>
          Your pet must be on a leash at all times when on property except for within
          designated play areas.
        </li>
        <li>No more than 2 pets are allowed per tent.</li>
        <li>Only pets weighing less than 75 pounds are allowed.</li>
        <li>All pets must be well behaved and socialize well with other animals and guests.</li>
        <li>
          Dog waste bags are provided throughout the property and trails. Please clean up
          after your dog and dispose of waste properly.
        </li>
        <li>
          With the exception of “Service Animals” as defined by U.S. DOJ, pets are not
          allowed in the lobby, spa or indoor dining areas.
        </li>
        <li>Animals are never allowed in hot tubs.</li>
        <li>
          Owners must be present, and pets must be restrained while any member of the
          Backland team is servicing the tent.
        </li>
        <li>
          Please ensure that your pet does not disrupt the “quiet enjoyment” of other guests
          due to excessive barking, especially during quiet hours 11pm to 7am.
        </li>
        <li>
          Your pet must never be left unattended in your tent. If your pet is left
          unattended and is the cause of disturbance, the camp reserves the right to contact
          the appropriate authorities to have your pet removed from the premises.
        </li>
        <li>Backland is not liable for any injury suffered by your pet while on property.</li>
        <li>
          You, the guest, accept full responsibility for any liability arising from your pet
          which includes property damage or personal injury to the camp, guests, staff, or
          3rd party vendors.
        </li>
      </ul>
    </LegalPage>
  );
}
